import {lazy} from 'react'

const PaymentCheckoutScreen = lazy(
  () => import(/* webpackChunkName: 'Checkout' */ './PaymentCheckoutScreen'),
)

export * from './PaymentCheckoutScreenParams'
export {PaymentCheckoutScreen}
